import Block from "@/components/wrappers/block"
import { useEffect } from "react"
import scrollSvg from "scroll-svg"
import styles from "./animated-svg.module.css"

export default function AnimatedSVG({ block }) {
  useEffect(() => {
    const svgPath = document.querySelector("#" + block.attrs.animated_svg_id)

    const options = {
      invert: false,
      draw_origin: "bottom",
      offset: 0,
      speed: 1,
      undraw: false
    }

    let svg = scrollSvg(svgPath, options)
    document.addEventListener("scroll", handleScrollFunction)

    function handleScrollFunction() {
      const percentage = svg.getPercentageDrawn()
      if (percentage == 100) {
        svg.stopAnimating()
        document.removeEventListener("scroll", handleScrollFunction)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Block block={block} className={styles.holder}>
      <div dangerouslySetInnerHTML={{ __html: block.attrs.content }}></div>
    </Block>
  )
}
